module.exports = __webpack_public_path__ + "img/bin.e9854e12.svg";